import { useQuery } from 'react-query';

import { queryKeys } from '../../utils/react-query';

type SystemMessage = {
  title: string;
  content: string;
  enabled: boolean;
};

type Response = {
  messages: SystemMessage[];
};

export const useSystemAlert = (): SystemMessage[] => {
  const alertUrl = window.config.VITE_SYSTEM_ALERT_URL ?? '';
  const { data } = useQuery(
    [queryKeys.systemAlert, alertUrl],
    async (): Promise<Response> => {
      const response = await fetch(alertUrl);

      if (!response.ok) {
        throw new Error(`Failed loading system alert. HTTP status: ${response.status}`);
      }

      return await response.json();
    },
    {
      enabled: Boolean(alertUrl),
      staleTime: 60 * 1000 // 1 minute
    }
  );

  return data?.messages.filter((message) => message.enabled) || [];
};
